












import { Vue, Component } from 'vue-property-decorator'
import { select } from 'components/LocaleSelect.vue'
import locales from 'src/i18n'
import { setLocale } from 'src/boot/i18n'

@Component
export default class LocaleChange extends Vue {

  get localeName (): string {
    return locales[this.$i18n.locale].messages.langname
  }

  async localeChage () {
    const locale = await select(this)
    setLocale(locale)
  }
}
